import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { pushTo } from "helpers/history"
import { PATH } from "constants/path"
import {
  ProjectDetail,
  defaultProjectDetail,
  STATUS_PROJECT_ROLE,
} from "pages/projects/types"
import {
  getProjectDetailMiddleware,
  getProjectRoleMiddleware,
} from "pages/projects/services/api"
import {
  IUseDefaultValueProps,
  useBoolean,
  useString,
  useWindowSize,
} from "helpers/hooks"
import { getBuildStatusMiddleware } from "../../project-component/services/api"
import Header from "../../project-build/organisms/ProjectBuildHeader"
import InfoDraftBuildCard from "../../project-build/organisms/InfoDraftBuildCard"
import {
  MENU_TAB_BUILD,
  ProjectBuildAdditionalDetail,
  ProjectBuildCommentDetail,
  ProjectBuildExtraDetail,
  ProjectBuildInvitessDetail,
  ProjectComponentBuildDetail,
} from "../../project-build/project-build.type"
import {
  deleteProjectBuildInviteeAddComponentMiddleware,
  getProjectBuildAdditionalInfoMiddleware,
  getProjectBuildAssignApproversMiddleware,
  getProjectBuildCommentsMiddleware,
  getProjectBuildInviteeMiddleware,
  postProjectBuildComponentSyncMiddleware,
  postProjectBuildSendInviteeMiddleware,
  putProjectBuildMiddleware,
} from "../../project-build/api.services"
import { PermissionProjectBuildPage } from "../../project-build/contexts/PermissionProjectBuildPage.context"
import ComponentBuildSyncCard from "../../project-build/organisms/ComponentBuildSyncCard"
import { SelectedDefaultProp } from "components/Select/types"
import MenuTabBuildCard from "../../project-build/molecules/MenuTabBuildCard"
import AdditionalInfoCard from "../../project-build/organisms/AdditionalInfoCard"
import CommentsCard from "../../project-build/organisms/CommentsCard"
import { cloneDeep, includes, isUndefined, orderBy, remove } from "lodash"
import { STATUS_BUILD } from "components/Status/types"
import InviteesInfoCard from "../../project-build/organisms/InviteesInfoCard"
import { checkPermissionPage, customLocalStorageHandler } from "helpers/utils"
import { ProjectComponentDetail } from "pages/project-component/types"
import ModalDelete from "components/ModalCustom/ModalDelete"
import { STATUS_RESPONSE } from "types"
import { toast } from "react-toastify"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { ReactComponent as ArrowLeftIcon } from "assets/images/icons/arrow-left.svg"
import { useAddComponentInInvitee } from "hooks/useAddComponentInInvitee"
import { FormBackup } from "components/FormBackup/FormBackup"

import { activityLogHelper, ActivityLogType } from "helpers/activity_log"
import { useShareInvitation } from "hooks/useShareInvitation"
import { getWorkerLocalStorageData } from "workers/utils"
import { EncryptedDataWarning } from "components/EncryptedDataWarning"
import { AddComponentInBuildDetail } from "../molecules/AddComponentInBuildDetail"
import { updateUnlistedComponentInBuildMiddleware } from "../builds.api"
import { configureStore } from "stores/configureStore"
import { closeModal, openModal } from "reducers/modal"
import { NAME_LOCALSTORAGE } from "constants/localStorage"
import Button from "components/Button/Button"
import ButtonHasIcon from "components/Button/ButtonHasIcon"
import { PERMISSIONS } from "constants/permissions"
import { FileIntegrityAndSignatureCheckComponentHistory } from "pages/project-component-detail/modal/FileIntegrityAndSignatureCheckComponentHistory"
import { EncryptionKeys } from "controllers/EncryptionController"
import { closeLoading, startLoading } from "reducers/loading"
import { usePageLayoutHealth } from "pages/layout/PageLayout"

interface Props {
  projectBuild: ProjectComponentBuildDetail
  isArchived: boolean | undefined
  showBuildDetailLayout: IUseDefaultValueProps
  onUpdateDataEditNameBuild: (
    updatedData: Partial<ProjectComponentBuildDetail>
  ) => void
  updatedAtBuild: string
  updateProjectBuild: () => Promise<ProjectComponentBuildDetail>
  isLoadingSkeletonBuild: boolean
}

const BuildDetail = (props: Props) => {
  const { isPreCheckReady, keyAvailability } = usePageLayoutHealth()
  const params = useParams<{
    status: string
    idProject: string
    idProjectBuild: string
  }>()
  const {
    showBuildDetailLayout,
    isArchived,
    onUpdateDataEditNameBuild,
    projectBuild,
    updatedAtBuild,
    updateProjectBuild,
  } = props
  const {
    syncNewVersionComponentToInvitee,
    currentMessageBackup,
    errorMessageBackup,
    isLoadingBackupInvitee,
    messageBackups,
    syncNewVersionComponentInvitee,
  } = useAddComponentInInvitee()

  const { acceptedSharingProject } = useShareInvitation()

  const idProjectParams = params?.idProject || ""
  const idProjectBuildParams = params?.idProjectBuild || ""
  const idStatusBuildParams = params?.status || ""
  const [projectDetail, setProjectDetail] =
    useState<ProjectDetail>(defaultProjectDetail)
  const isLoading = useBoolean()
  // const [projectBuild, setProjectBuild] = useState<ProjectComponentBuildDetail>(
  //   emptyProjectBuildDetail
  // )
  const archiveProject = useBoolean(true)
  const viewOnlyShare = useBoolean(true)
  const archiveBuild = useBoolean(false)
  const [listStatus, setListStatus] = useState<SelectedDefaultProp[]>([])
  const { isMobile } = useWindowSize()
  const activeTab = useString(
    isMobile ? MENU_TAB_BUILD.COMPONENT : MENU_TAB_BUILD.COMMENTS
  )
  const [additionals, setAdditionals] = useState<
    ProjectBuildAdditionalDetail[]
  >([])
  const [extras, setExtras] = useState<ProjectBuildExtraDetail[]>([])
  const [invitess, setInvitess] = useState<ProjectBuildInvitessDetail[]>([])
  const [comments, setComments] = useState<ProjectBuildCommentDetail[]>([])
  const [commentsPage, setCommentsPage] = useState(1)
  const [commentsTotal, setCommentsTotal] = useState(0)
  const [isLoadingMoreComments, setIsLoadingMoreComments] = useState(false)
  const [approvers, setApprovers] = useState<
    {
      id: string
      email: string
      fullname: string
      avatar: string | null
    }[]
  >([])
  const isSyncComponent = useBoolean(false)
  const projectBuildComponentSyncId = useString("")
  const mainVersionId = useString("")

  // const sizeWindow = useWindowSize()
  const isDeleted = projectBuild.status === STATUS_BUILD.DELETED
  const { userId } = getWorkerLocalStorageData()
  const openUpdateComponent = useBoolean(false)
  const projectBuildTabLocal = customLocalStorageHandler(
    NAME_LOCALSTORAGE.PROJECT_BUILD_TAB
  )
  const activeTabLocal = projectBuildTabLocal.storageData?.[projectBuild.id]
  const [selectAddComponent, setSelectAddComponent] = useState<
    Record<string, string>
  >({})
  const hasMoreComment = useBoolean(false)

  useEffect(() => {
    if (!isPreCheckReady) {
      return
    }
    if (!idProjectParams) {
      // pushTo(PATH.projects)
      return
    }
    getProjectDetail()
    return () => {
      openUpdateComponent.setValue(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    idProjectParams,
    idProjectBuildParams,
    idStatusBuildParams,
    isPreCheckReady,
  ])

  useEffect(() => {
    if (!activeTabLocal) {
      const defaultTab = isMobile
        ? MENU_TAB_BUILD.COMPONENT
        : MENU_TAB_BUILD.COMMENTS
      activeTab.setValue(defaultTab)
      return
    }
    activeTab.setValue(activeTabLocal)
  }, [activeTabLocal])

  const getProjectDetail = async () => {
    if (!isPreCheckReady) {
      return
    }
    isLoading.setValue(true)
    try {
      const dataProjectRoleRes = await getProjectRoleMiddleware(idProjectParams)
      const dataProjectDetailRes = await getProjectDetailMiddleware(
        idProjectParams
      )
      archiveProject.setValue(Boolean(dataProjectDetailRes.is_archived))
      viewOnlyShare.setValue(
        dataProjectRoleRes.role === STATUS_PROJECT_ROLE.VIEWER
      )
      setProjectDetail(dataProjectDetailRes)
      await acceptedSharingProject(dataProjectDetailRes)
      await getProjectBuild(idProjectBuildParams)
      openUpdateComponent.setValue(false)
      isLoading.setValue(false)
    } catch (error) {
      isLoading.setValue(false)
      pushTo(PATH.projects)
    }
  }
  const getProjectBuild = async (idBuild: string, loading = false) => {
    if (!isPreCheckReady) {
      return
    }
    try {
      archiveBuild.setValue(Boolean(projectBuild.is_archived))
      const dataBuildStatusRes = await getBuildStatusMiddleware()
      setListStatus([
        ...dataBuildStatusRes.map((i) => ({
          label: i.key,
          value: String(i.value),
        })),
      ])

      if (projectBuild.status !== STATUS_BUILD.COMMITTED) {
        await getInvitees(idBuild)
      }
      await getAdditional(idBuild)
      await getComments(idBuild, false, 1)
      await getAssignApprovers(idBuild)

      if (loading) {
        isLoading.setValue(false)
      }
    } catch (error) {
      if (loading) {
        isLoading.setValue(false)
      }
      pushTo(PATH.projectComponent, {
        idProject: idProjectParams,
      })
    }
  }
  const getAdditional = async (idBuild: string, loading = false) => {
    if (!isPreCheckReady) {
      return
    }
    const dataAdditionalRes = await getProjectBuildAdditionalInfoMiddleware(
      idBuild
    )
    setAdditionals(dataAdditionalRes)
    if (loading) {
      isLoading.setValue(false)
    }
  }

  const getComments = async (
    idBuild: string,
    loading = false,
    newPage?: number
  ) => {
    if (!isPreCheckReady) {
      return
    }
    const page = newPage || commentsPage
    const pageSize = 30
    const dataCommentsRes = await getProjectBuildCommentsMiddleware(idBuild, {
      page: page,
      pageSize,
    })
    hasMoreComment.setValue(dataCommentsRes.data.length === pageSize)
    if (params && page > 1) {
      setComments((prev) =>
        orderBy([...prev, ...dataCommentsRes.data], "created_at", "asc")
      )
    } else {
      setComments(orderBy(dataCommentsRes.data, "created_at", "asc"))
      setCommentsPage(1)
    }
    setCommentsTotal(dataCommentsRes.total || 0)
    if (loading) {
      isLoading.setValue(false)
    }
  }

  const loadMoreComments = async (commentFromScrollId?: string) => {
    if (!isPreCheckReady) {
      return
    }
    if (!commentFromScrollId) {
      if (isLoadingMoreComments) return
      setIsLoadingMoreComments(true)
      const nextPage = commentsPage + 1
      setCommentsPage(nextPage)
      try {
        await getComments(projectBuild.id, false, nextPage)
      } catch (error) {
        // Handle error
      } finally {
        setIsLoadingMoreComments(false)
      }
      return
    }
    if (!hasMoreComment.value) {
      toast(
        <LabelNotificationPage
          messenger="Reply message not found"
          type="warning"
        />
      )
      return
    }
    let isLoaded = true
    let newPage = commentsPage
    let newCommentFrom: any = null
    let messagesResult: any = []
    let newMoreData = false
    configureStore.dispatch(startLoading())
    do {
      const params = {
        page: newPage + 1,
        pageSize: 30,
      }
      newPage = newPage + 1
      const dataCommentsRes = await getProjectBuildCommentsMiddleware(
        projectBuild.id,
        params,
        true
      )
      const newMessages = dataCommentsRes.data as any[]
      newCommentFrom = newMessages?.find((el) => el.id === commentFromScrollId)
      newMoreData = newMessages.length < 30 ? false : true
      messagesResult = messagesResult.concat(newMessages)
      if (newCommentFrom || !newMoreData) {
        isLoaded = false
      }
    } while (isLoaded)
    let newComments = cloneDeep(comments)
    newComments = orderBy(messagesResult, "created_at", "asc").concat(
      newComments
    )
    setCommentsPage(newPage)
    setComments(newComments)
    hasMoreComment.setValue(newMoreData)
    setTimeout(() => {
      closeLoading()
      if (newCommentFrom) {
        const el = document.getElementById(`msg-${commentFromScrollId}`)
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" })
          el.classList.add("highlight-message")
          setTimeout(() => el.classList.remove("highlight-message"), 2500)
        }
      } else {
        toast(
          <LabelNotificationPage
            messenger="Reply message not found"
            type="warning"
          />
        )
      }
    }, 500)
  }

  const getAssignApprovers = async (idBuild: string, loading = false) => {
    if (!isPreCheckReady) {
      return
    }
    try {
      const dataApprovers = await getProjectBuildAssignApproversMiddleware(
        idBuild
      )
      setApprovers(dataApprovers)
      if (loading) {
        isLoading.setValue(false)
      }
    } catch (error) {
      if (loading) {
        isLoading.setValue(false)
      }
    }
  }

  const getInvitees = async (
    idBuild: string,
    loading = false,
    inviteeId?: string,
    newAddedCC?: string[]
  ) => {
    if (!isPreCheckReady) {
      return
    }
    const dataInvitees = await getProjectBuildInviteeMiddleware(idBuild)
    setInvitess(dataInvitees)
    if (loading) {
      isLoading.setValue(false)
    }
    if (inviteeId && !isUndefined(newAddedCC) && newAddedCC.length) {
      const inviteeDefault = dataInvitees.find((el) => el.id === inviteeId)
      if (inviteeDefault) {
        automaticallySendNewCC(inviteeDefault, newAddedCC, inviteeId)
      }
    }
  }

  const automaticallySendNewCC = async (
    inviteeDefault: ProjectBuildInvitessDetail,
    newAddedCC: string[],
    inviteeId: string
  ) => {
    const generateDataKeyPairUsers = await syncNewVersionComponentInvitee(
      inviteeDefault.project_build_components,
      projectBuild.project_id,
      inviteeDefault,
      projectBuild.id,
      inviteeDefault.conversation_id,
      newAddedCC
    )

    postProjectBuildSendInviteeMiddleware(
      inviteeId,
      "Send",
      async (type: STATUS_RESPONSE, _messenger: string) => {
        if (type === STATUS_RESPONSE.SUCCESS) {
          toast(
            <LabelNotificationPage
              messenger={`Send invite:${newAddedCC
                .map((el) => el)
                .join(", ")}  successfully!`}
              type={type}
            />
          )
          getInvitees(projectBuild.id, true)
        }
      },
      newAddedCC,
      generateDataKeyPairUsers
    )
  }
  const onChangeTab = (_newIndex: number, newLabel?: string) => () => {
    if (!isPreCheckReady) {
      return
    }
    if (!newLabel) {
      return
    }
    if (activeTab.value === newLabel) {
      return
    }
    if (newLabel !== MENU_TAB_BUILD.COMPONENT) {
      projectBuildTabLocal.handleSetLocalStorage({
        ...projectBuildTabLocal.storageData,
        [projectBuild.id]: newLabel,
      })
    }

    activeTab.setValue(newLabel)
    isLoading.setValue(true)
    switch (newLabel) {
      case MENU_TAB_BUILD.INVITEES:
        getInvitees(projectBuild.id, true)
        break
      case MENU_TAB_BUILD.ADDITIONAL:
        getAdditional(projectBuild.id, true)
        break
      case MENU_TAB_BUILD.COMMENTS:
        getComments(projectBuild.id, true, 1)
        break
      // default:
      //   getExtra(projectBuild.id, true)
      //   break
    }
  }
  const updateWhenCreateAdditional = () => {
    isLoading.setValue(true)
    getAdditional(projectBuild.id, true)
  }
  const updateWhenDeleteAdditional = (oldAdditional: string) => {
    const newAdditionals = cloneDeep(additionals)
    remove(newAdditionals, (el) => el.id === oldAdditional)
    setAdditionals(newAdditionals)
  }

  const updateWhenCreateComment = () => {
    isLoading.setValue(true)
    getComments(projectBuild.id, true, 1)
  }

  const handleChangeDataVendor = async (
    _newInvitees?: ProjectBuildInvitessDetail,
    inviteeId?: string,
    newAddedCC?: string[]
  ) => {
    isLoading.setValue(true)
    await getInvitees(projectBuild.id, true, inviteeId, newAddedCC)
  }

  const handleUnListedComponent = async (
    projectBuildComponentId: string,
    componentCode: string,
    projectComponentId: string,
    version: string,
    newArchive: boolean
  ) => {
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: newArchive
              ? `When the component ${componentCode}/${version} is unlisted, it will be removed from all conversation instances used within build ${projectBuild.code}. Furthermore, any associated shared components and shared keys will also be deleted.`
              : `Are you sure you want to restore this component ${componentCode}/${version}?`,
            label: `Warning`,
            content: newArchive
              ? `Would you like to proceed?`
              : `This action cannot be undone`,
            styleTitle: { textAlign: "center" },
            titleButton: newArchive ? "Proceed" : "Restore",
            colorYellowButton: !newArchive,
            onSubmit: async () => {
              try {
                await updateUnlistedComponentInBuildMiddleware(
                  projectBuildComponentId,
                  await activityLogHelper.toEncryptedMessage(
                    newArchive
                      ? ActivityLogType.UnlistedComponent
                      : ActivityLogType.RestoreComponent,
                    {
                      componentCode: `${componentCode}/${version}`,
                      buildCode: projectBuild.code,
                    }
                  )
                )

                await updateProjectBuild()
                const newInvitess = cloneDeep(invitess)
                if (newArchive) {
                  for (const el of newInvitess) {
                    const componentExist = el.project_build_components.find(
                      (elComponent) =>
                        elComponent.project_component_id === projectComponentId
                    )
                    if (componentExist) {
                      await deleteProjectBuildInviteeAddComponentMiddleware(
                        componentExist.id,
                        `${componentExist.code}/${componentExist.version}`,
                        el.conversation_id
                      )
                    }
                  }
                  toast(
                    <LabelNotificationPage
                      messenger={`Updated ${newArchive ? "unlisted" : "restore"
                        } component successfully!`}
                      type="success"
                    />
                  )
                  closeModal()
                  await getInvitees(projectBuild.id, true)
                } else {
                  closeModal()
                }
              } catch (error) {
                closeModal()
                toast(
                  <LabelNotificationPage
                    messenger={`Updated ${newArchive ? "unlisted" : "restore"
                      } component failed`}
                    type="error"
                  />
                )
              }
            },
          },
        },
      })
    )
  }
  const renderComponentBuildSyncCard = () => (
    <div className="pr-6 h-full md:pr-0 ">
      <ComponentBuildSyncCard
        projectBuild={projectBuild}
        gridCols={"grid-cols-1"}
        onSyncDataComponent={onSyncDataComponent}
        handleUnListedComponent={handleUnListedComponent}
        openUpdateComponent={openUpdateComponent}
      />
    </div>
  )

  const renderTab = () => {
    const finalActiveTab =
      activeTab.value === MENU_TAB_BUILD.INVITEES &&
        projectBuild.status === STATUS_BUILD.COMMITTED
        ? MENU_TAB_BUILD.ADDITIONAL
        : activeTab.value
    switch (finalActiveTab) {
      case MENU_TAB_BUILD.COMPONENT:
        return renderComponentBuildSyncCard()
      case MENU_TAB_BUILD.INVITEES:
        return (
          <InviteesInfoCard
            idProjectBuild={projectBuild.id}
            handleChangeData={handleChangeDataVendor}
            invitess={invitess}
            sumComponent={
              projectBuild.components.filter(
                (el) => !el.is_build_component_archived
              ).length
            }
            isDeleted={isDeleted}
          />
        )
      case MENU_TAB_BUILD.COMMENTS:
        return (
          <CommentsCard
            comments={comments}
            idProjectBuild={projectBuild.id}
            updateWhenCreateComment={updateWhenCreateComment}
            isEditorInput={checkPermissionPage(
              PERMISSIONS.PROJECT_BUILD_CREATE_ADDITIONAL_INFO,
              {
                project: archiveProject.value,
                build: archiveBuild.value,
                viewShare: viewOnlyShare.value,
              }
            )}
            isDeleted={isDeleted}
            subNameDownload={`Comments: ${projectBuild.code}`}
            loadMoreComments={loadMoreComments}
            hasMoreComments={hasMoreComment.value}
            isLoadingMore={isLoadingMoreComments}
            approvers={approvers}
            commentsPage={commentsPage}
            isOwner={
              projectBuild.created_by === userId ||
              projectDetail.created_by === userId
            }
          />
        )
      default:
        return (
          <AdditionalInfoCard
            additionals={additionals}
            idProjectBuild={projectBuild.id}
            updateWhenCreateAdditional={updateWhenCreateAdditional}
            updateWhenDeleteAdditional={updateWhenDeleteAdditional}
            isEditorInput={checkPermissionPage(
              PERMISSIONS.PROJECT_BUILD_CREATE_ADDITIONAL_INFO,
              {
                project: archiveProject.value,
                build: archiveBuild.value,
                viewShare: viewOnlyShare.value,
              }
            )}
            isLabel
            isDeleteComment={checkPermissionPage(
              PERMISSIONS.PROJECT_BUILD_CREATE_ADDITIONAL_INFO,
              {
                project: archiveProject.value,
                build: archiveBuild.value,
                viewShare: viewOnlyShare.value,
              }
            )}
            isDeleted={isDeleted}
            subNameDownload={`Additional info: ${projectBuild.code}`}
            styleListAdditional={{
              overflow: "auto",
            }}
          />
        )
    }
  }

  const onSyncDataComponent = (newItem: ProjectComponentDetail) => (event) => {
    event.preventDefault()
    event.stopPropagation()
    isSyncComponent.setValue(true)
    projectBuildComponentSyncId.setValue(newItem.project_build_component_id)
    mainVersionId.setValue(newItem.main_version_id)
  }
  const onSynComponent = () => {
    if (!projectBuildComponentSyncId.value || !mainVersionId.value) {
      toast(
        <LabelNotificationPage
          messenger="Please select a component to sync"
          type="error"
        />
      )
      return
    }
    isLoading.setValue(true)
    const component = projectBuild.components.find(
      (item) =>
        item.project_build_component_id === projectBuildComponentSyncId.value
    ) as any
    isSyncComponent.setValue(false)
    const projectId = projectBuild.project_id
    const projectKeys = JSON.parse(
      localStorage.getItem(EncryptionKeys.projectEncryptionKeys) || "{}"
    )
    const projectKey = projectKeys[projectId]
    if (!projectKey) {
      toast(
        <LabelNotificationPage
          messenger={"Project key not found!"}
          type={STATUS_RESPONSE.ERROR}
        />
      )
      return
    }
    configureStore.dispatch(
      openModal({
        type: "Check",
        props: {
          checkModal: {
            content: (
              <FileIntegrityAndSignatureCheckComponentHistory
                isCallAPI={true}
                projectKey={projectKey}
                projectComponentHistory={mainVersionId.value}
                label="Master -"
                checkFileSucess={() => {
                  postProjectBuildComponentSyncMiddleware(
                    projectBuildComponentSyncId.value,
                    async (
                      type: STATUS_RESPONSE,
                      messenger: string,
                      data: any
                    ) => {
                      toast(
                        <LabelNotificationPage
                          messenger={messenger}
                          type={type}
                        />
                      )
                      if (type === STATUS_RESPONSE.SUCCESS) {
                        isSyncComponent.setValue(false)
                        if (data.id && component) {
                          configureStore.dispatch(startLoading())
                          await syncNewVersionComponentToInvitee(
                            projectBuild.project_id,
                            projectBuild.id,
                            component.id,
                            data.id,
                            "",
                            `${data.code}`,
                            false
                          )
                        }
                        await updateProjectBuild()
                        getProjectBuild(idProjectBuildParams, true)
                      } else {
                        isLoading.setValue(false)
                      }
                    },

                    component?.code,
                    component?.main_version
                  )
                  closeModal()
                }}
                checkFileError={(
                  newErrors: { name: string; error: string }[]
                ) => {
                  if (newErrors.length) {
                    toast(
                      <LabelNotificationPage
                        messenger={newErrors
                          .map((el) => `File ${el.name}: ${el.error}`)
                          .join(", ")}
                        type={STATUS_RESPONSE.ERROR}
                      />
                    )
                  } else {
                    toast(
                      <LabelNotificationPage
                        messenger={"File integrity and signature check failed"}
                        type={STATUS_RESPONSE.ERROR}
                      />
                    )
                  }
                  closeModal()
                }}
              />
            ),
            label: `File Integrity & Signature Check`,
          },
        },
      })
    )
  }

  const getButtonNameAddOrUpdateComponent = () => {
    const hasComponents = projectBuild.components.length > 0
    const isUpdateOpen = openUpdateComponent.value

    if (isUpdateOpen) {
      return hasComponents ? "Close update components" : "Close add components"
    }

    return hasComponents ? "Update components" : "Add components"
  }

  const handleAddComponentInBuild = () => {
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: `Build ${projectBuild.code} is currently status ${projectBuild.status}. This action may affect the build and cannot be undone`,
            label: `Warning`,
            content: `Are you sure you want to continue?`,
            styleTitle: { textAlign: "center" },
            titleButton: "Continue",
            colorYellowButton: true,
            onSubmit: () => {
              putProjectBuildMiddleware(
                projectBuild.id,
                {
                  project_component_ids: Object.values(selectAddComponent),
                },
                async (type: STATUS_RESPONSE, messenger: string) => {
                  if (type === STATUS_RESPONSE.SUCCESS) {
                    toast(
                      <LabelNotificationPage
                        messenger={messenger}
                        type={type}
                      />
                    )
                    closeModal()
                    openUpdateComponent.setValue(false)
                    setSelectAddComponent({})
                    await updateProjectBuild()
                  } else {
                    toast(
                      <LabelNotificationPage
                        messenger={messenger}
                        type={type}
                      />
                    )
                    closeModal()
                  }
                }
              )
            },
          },
        },
      })
    )
  }

  const renderButtonUpdateComponent = () => {
    const hasSelectedComponents = Object.values(selectAddComponent).length > 0
    if (hasSelectedComponents) {
      return (
        <ButtonHasIcon
          title="Add selected and close"
          onClick={handleAddComponentInBuild}
          widthButton={309}
          showIcon={false}
          heightButton={35}
        />
      )
    }
    return (
      <Button
        title={getButtonNameAddOrUpdateComponent()}
        onClick={() => openUpdateComponent.setValue(!openUpdateComponent.value)}
        sizeBtn="small"
        colorBtn={openUpdateComponent.value ? "white" : "yellow"}
        isDisabledBtn
        widthBtn={309}
        heightBtn={35}
      />
    )
  }
  const renderLayout = () => {
    if (!projectBuild.id || projectBuild.id !== idProjectBuildParams) {
      return null
    }
    const isProjectKeyAvailable = Boolean(
      keyAvailability.project[projectBuild.project_id]
    )
    if (!isProjectKeyAvailable) {
      return (
        <EncryptedDataWarning
          type="project"
          isOwner={projectDetail.created_by === userId}
          name={`"${projectBuild.project_name}"`}
          id={projectBuild.project_id}
          isEncrypted={projectBuild.is_encrypted_project || false}
        />
      )
    }
    const isBuildKeyAvailable = Boolean(keyAvailability.build[projectBuild.id])
    if (!isBuildKeyAvailable) {
      return (
        <EncryptedDataWarning
          type="build"
          isOwner={projectBuild.created_by === userId}
          name={`ID: ${projectBuild.code}`}
          id={projectBuild.id}
          isEncrypted={projectBuild.is_encrypted_project || false}
        />
      )
    }

    return (
      <div className=" h-full flex flex-col overflow-auto">
        <InfoDraftBuildCard
          projectBuild={projectBuild}
          onUpdateDataEditNameBuild={onUpdateDataEditNameBuild}
          showButtonUpdateComponent={openUpdateComponent.value}
        />
        <div
          className="block md:grid h-full overflow-auto"
          style={{
            borderTop: "1px solid #E4E4E4",
            gridTemplateColumns: "358px calc(100% - 358px)",
          }}
        >
          <div
            className={`border-r border-[#E4E4E4] relative overflow-hidden ${isMobile ? "" : "pb-6"
              }`}
            style={{
              paddingTop: isMobile
                ? 0
                : includes(
                  [
                    STATUS_BUILD.COMPLETED,
                    STATUS_BUILD.CANCELLED,
                    STATUS_BUILD.DELETED,
                  ],
                  projectBuild.status
                )
                  ? 24
                  : 55,
            }}
          >
            <div className="hidden md:block pl-6 pr-6 h-full overflow-auto">
              {renderComponentBuildSyncCard()}
            </div>
            <div className="absolute top-[6px] left-[24px]">
              {!isMobile &&
                !includes(
                  [
                    STATUS_BUILD.CANCELLED,
                    STATUS_BUILD.COMPLETED,
                    STATUS_BUILD.DELETED,
                  ],
                  projectBuild.status
                ) &&
                !checkPermissionPage(PERMISSIONS.PROJECT_BUILD_EDIT, {
                  project: archiveProject.value,
                  build: archiveBuild.value,
                  viewShare: viewOnlyShare.value,
                })
                ? renderButtonUpdateComponent()
                : null}
            </div>
          </div>
          {openUpdateComponent.value ? (
            <AddComponentInBuildDetail
              projectId={projectBuild.project_id}
              projectBuildId={projectBuild.id}
              listIdComponentActive={projectBuild.components.map((el) => el.id)}
              updateProjectBuild={updateProjectBuild}
              buildCode={projectBuild.code}
              openUpdateComponent={openUpdateComponent.value}
              projectBuildStatus={projectBuild.status}
              objActive={selectAddComponent}
              setObjActive={setSelectAddComponent}
            />
          ) : (
            <div className="flex flex-col h-full pl-6 pb-[12px] overflow-auto bg-grayWhite2 md:bg-white">
              <MenuTabBuildCard
                activeTab={
                  activeTab.value === MENU_TAB_BUILD.INVITEES &&
                    projectBuild.status === STATUS_BUILD.COMMITTED
                    ? MENU_TAB_BUILD.ADDITIONAL
                    : activeTab.value
                }
                onChangeTab={onChangeTab}
                additional={{
                  isRead: !projectBuild.is_read_additional_info
                    ? projectBuild.is_read_additional_info
                    : false,
                  count: additionals.length,
                }}
                extra={{
                  isRead: !projectBuild.is_read_extra_info
                    ? projectBuild.is_read_extra_info
                    : false,
                  count: extras.length,
                }}
                isInvitee={
                  projectBuild.status !== STATUS_BUILD.COMMITTED ? true : false
                }
                invitees={{
                  count: invitess.length,
                  isRead: false,
                }}
                comments={{
                  count: commentsTotal,
                  isRead: false,
                }}
              />
              {renderTab()}
            </div>
          )}
        </div>
      </div>
    )
  }
  return (
    <PermissionProjectBuildPage.Provider
      value={{
        archiveProject: archiveProject.value,
        archiveBuild: isUndefined(isArchived)
          ? Boolean(projectBuild.is_archived)
          : isArchived,
        viewOnlyShare: viewOnlyShare.value,
        listStatus,
        status: projectBuild.status,
        tabMenu: activeTab.value,
        projectBuild: projectBuild,
      }}
    >
      <div className="flex flex-col w-full border-l border-[#E4E4E4] h-full">
        <div className="min-h-[48px] flex justify-between items-center bg-white">
          <div
            className="flex md:hidden p-6 "
            onClick={() => {
              showBuildDetailLayout.setValue(false)
            }}
          >
            <ArrowLeftIcon />
          </div>
          <div className="md:w-full h-full">
            <Header
              projectDetail={projectDetail}
              projectBuild={projectBuild}
              updatedAtBuild={updatedAtBuild}
            />
          </div>
        </div>
        {renderLayout()}
      </div>

      {isSyncComponent.value && (
        <ModalDelete
          onCloseModal={() => isSyncComponent.setValue(false)}
          title={`Update to the latest version from the master branch and cannot be undone.`}
          content=""
          label={`Confirmation`}
          onSubmit={onSynComponent}
          colorYellowButton
          titleButton="Confirm"
          styleTitle={{
            textAlign: "center",
          }}
        />
      )}
      {isLoadingBackupInvitee.value && messageBackups.length ? (
        <FormBackup
          messageBackups={messageBackups}
          currentBackup={currentMessageBackup}
          errorMessageBackup={errorMessageBackup.value}
        />
      ) : null}
    </PermissionProjectBuildPage.Provider>
    // </PageLayout>
  )
}

export default BuildDetail
